import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import CircleIcon from "./circleIcon";
import SliderWithPercent from "../sliderWithPercent";
import helper from "./helper";
import Delete from "./Delete.jpeg";
import Undo from "./Undo.jpeg";
import AssetClassGroup from "./AssetClassGroup";
import ClassificationGroup from "./ClassificationGroup";
import ToggleSwitch from "../toggleSwitch/index";
import Bars from "./bars";
import Cells from "./cells";
import "./TreeTableWithSlider.style.scss";
import { connect } from "react-redux";
import { dispatch } from "d3";
import { uniqueId } from "lodash";

const regex = /([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\:\&\s])/g;
const node = React.createRef();

class TreeTableWithSlider extends Component {
  // constructor() {
  //   super();
  //   this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
  // }
  state = {
    slider_colors: [
      "#5099d4",
      "#fa7d2e",
      "#8A8A8A",
      "#B53F18",
      "#747A80",
      "#F26F6F",
      "#BA3F3F",
    ],
    classification_colors: [
      "#e08a55",
      "#577dc5",
      "#85b15d",
      "#68399b",
      "#7b53a2",
    ],
    activeSliders: [],
    grouped_data: [],
    styleAssetClassGroups: {},
    colorsAssetClassGroups: {},
    colorClassificationGroup: {},
    asset_class_validated_data: [],
    classification_validated_data: [],
    style_validated_data: [],
    allocation_max_warning: false,
    resetRangeSlider: false,
    listOfSecuritiesToDelete_manager_selection: [],
    toggleStatsStatus: false,
    toggleChartStatus: false,
    opened_style: [],
    SecurityAddedManuallyCount: 0,
  };
  componentDidMount() {
    const {
      getScenarioShortlist,
      optimization_params,
      activePortfolioID,
      overall_focus,
      asset_class,
      styles,
      validate_slider_limits,
      setFundTypeStyleError,
      single_asset_class_style,
      setSymbolsOrder,
      universeLiteValidation,
      ownSecurityUniverse,
      asset_class_array,
      SecurityAddedManually,
    } = this.props;

    const { slider_colors, classification_colors } = this.state;
    if (validate_slider_limits && setFundTypeStyleError) {
      setFundTypeStyleError(false);
    }
    if (getScenarioShortlist && getScenarioShortlist.length > 0) {
      // display single table with including cash in fund type
      let asset_class_length_without_cash = overall_focus
        .map((e) => e.name)
        .filter(
          (a, i, arr) =>
            arr.indexOf(a) === i &&
            a !== null &&
            a !== undefined &&
            a.toLowerCase() !== "cash"
        );
      let multiGroupingData = helper.multiGroupingData({
        Data: getScenarioShortlist,
        single_asset_class_style,
        asset_class_length: asset_class_length_without_cash,
      });
      let colorsAssetClassGroups = this.getColorsForCircleIcons({
        array: overall_focus,
        colorList: slider_colors,
      });
      let colorClassificationGroup = this.getColorsForCircleIcons({
        array: asset_class,
        colorList: classification_colors,
      });

      if (setSymbolsOrder) {
        setSymbolsOrder(multiGroupingData.symbol_order);
      }
      this.setState({
        grouped_data: multiGroupingData.grouped_data,
        styleAssetClassGroups: multiGroupingData.styleAssetClassGroups,
        colorsAssetClassGroups,
        colorClassificationGroup,
      });

      this.validateSliderData({
        overall_focus,
        asset_class,
        styles,
        optimization_params,
        getScenarioShortlist,
        activePortfolioID,
        validate_slider_limits,
        setFundTypeStyleError,
        universeLiteValidation,
        ownSecurityUniverse,
      });
    }

    document.addEventListener("click", this.handleClickOutside, false);

    // setting cash value min to 0 ,max to 100 - sum of asset class excluded class
    // this.set_cash_assetClass_min_max_value();
    let { SecurityAddedManuallyCount } = this.state;
    console.log(
      "first- from did mount",
      SecurityAddedManually,
      SecurityAddedManuallyCount
    );
    if (SecurityAddedManually.length != SecurityAddedManuallyCount) {
      console.log(
        "second - from did mount",
        SecurityAddedManually,
        SecurityAddedManuallyCount
      );
      this.setState({
        SecurityAddedManuallyCount: SecurityAddedManually.length,
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    const {
      getScenarioShortlist,
      optimization_params,
      activePortfolioID,
      overall_focus,
      asset_class,
      styles,
      validate_slider_limits,
      setFundTypeStyleError,
      single_asset_class_style,
      setSymbolsOrder,
      universeLiteValidation,
      ownSecurityUniverse,
      asset_class_array,
      SecurityAddedManually,
    } = nextProps;
    const { slider_colors, classification_colors, SecurityAddedManuallyCount } =
      this.state;

    if (
      getScenarioShortlist &&
      getScenarioShortlist.length > 0 &&
      (JSON.stringify(getScenarioShortlist) !==
        JSON.stringify(this.props.getScenarioShortlist) ||
        JSON.stringify(this.props.overall_focus) !==
          JSON.stringify(overall_focus) ||
        JSON.stringify(this.props.asset_class) !==
          JSON.stringify(asset_class) ||
        JSON.stringify(this.props.styles) !== JSON.stringify(styles))
    ) {
      if (validate_slider_limits && setFundTypeStyleError) {
        setFundTypeStyleError(false);
      }

      let asset_class_length_without_cash = overall_focus
        .map((e) => e.name)
        .filter(
          (a, i, arr) =>
            arr.indexOf(a) === i &&
            a !== null &&
            a !== undefined &&
            a.toLowerCase() !== "cash"
        );
      let multiGroupingData = helper.multiGroupingData({
        Data: getScenarioShortlist,
        single_asset_class_style,
        asset_class_length: asset_class_length_without_cash,
      });
      let colorsAssetClassGroups = this.getColorsForCircleIcons({
        array: overall_focus,
        colorList: slider_colors,
      });
      let colorClassificationGroup = this.getColorsForCircleIcons({
        array: asset_class,
        colorList: classification_colors,
      });

      if (
        setSymbolsOrder &&
        this.props.activePortfolioID !== activePortfolioID
      ) {
        setSymbolsOrder(multiGroupingData.symbol_order);
      }

      this.setState({
        grouped_data: multiGroupingData.grouped_data,
        styleAssetClassGroups: multiGroupingData.styleAssetClassGroups,
        colorsAssetClassGroups,
        colorClassificationGroup,
      });
      this.validateSliderData({
        overall_focus,
        asset_class,
        styles,
        optimization_params,
        getScenarioShortlist,
        activePortfolioID,
        validate_slider_limits,
        setFundTypeStyleError,
        universeLiteValidation,
        ownSecurityUniverse,
      });
    }

    if (this.props.activePortfolioID !== activePortfolioID) {
      // setting cash value min to 0 ,max to 100 - sum of asset class excluded class
      this.set_cash_assetClass_min_max_value();
      this.setState({
        resetRangeSlider: true,
        opened_style: [],
      });
      setTimeout(
        () =>
          this.setState({
            resetRangeSlider: false,
          }),
        100
      );
    }
    console.log(
      "first - from comp will recieve props",
      SecurityAddedManually,
      SecurityAddedManuallyCount
    );
    if (SecurityAddedManually.length != SecurityAddedManuallyCount) {
      console.log(
        "second -comp will recieve props",
        SecurityAddedManually,
        SecurityAddedManuallyCount
      );
      this.setState({
        SecurityAddedManuallyCount: SecurityAddedManually.length,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, false);
  }
  validateSliderData = ({
    overall_focus,
    asset_class,
    styles,
    optimization_params,
    getScenarioShortlist,
    activePortfolioID,
    validate_slider_limits,
    setFundTypeStyleError,
    universeLiteValidation,
    ownSecurityUniverse,
  }) => {
    if (validate_slider_limits) {
      setFundTypeStyleError(false);
    }
    // validating asset_class, classification, style and setting to state
    this.assetClass_validate_and_modify({
      optimization_params,
      overall_focus,
      getScenarioShortlist,
      activePortfolioID,
      validate_slider_limits,
      setFundTypeStyleError,
      universeLiteValidation,
      ownSecurityUniverse,
    });
    this.classification_validation_and_modify({
      optimization_params,
      asset_class,
      getScenarioShortlist,
      activePortfolioID,
      validate_slider_limits,
      setFundTypeStyleError,
      universeLiteValidation,
      ownSecurityUniverse,
    });
    this.style_validation_and_modify({
      styles,
      optimization_params,
      getScenarioShortlist,
      activePortfolioID,
      validate_slider_limits,
      setFundTypeStyleError,
      universeLiteValidation,
      ownSecurityUniverse,
    });
  };
  assetClass_validate_and_modify = ({
    optimization_params,
    overall_focus,
    getScenarioShortlist,
    activePortfolioID,
    validate_slider_limits,
    setFundTypeStyleError,
    universeLiteValidation,
    ownSecurityUniverse,
  }) => {
    // relaxing asset class validation
    // if (validate_slider_limits && optimization_params && overall_focus) {
    //   let assetClassSliderValidation = helper.assetClassSliderValidation({
    //     asset_class: overall_focus,
    //     symbols: getScenarioShortlist,
    //     upper_bounds: optimization_params[activePortfolioID]["upper_bounds"],
    //     setFundTypeStyleError,
    //     universeLiteValidation,
    //     ownSecurityUniverse,
    //   });

    //   this.setState({
    //     asset_class_validated_data: assetClassSliderValidation,
    //   });
    // } else {
    this.setState({
      asset_class_validated_data: overall_focus,
    });
    // }
  };

  classification_validation_and_modify = ({
    optimization_params,
    asset_class,
    getScenarioShortlist,
    activePortfolioID,
    validate_slider_limits,
    setFundTypeStyleError,
    universeLiteValidation,
    ownSecurityUniverse,
  }) => {
    if (validate_slider_limits && optimization_params && asset_class) {
      let classificationValidation = helper.classificationSliderValidation({
        classification: asset_class,
        symbols: getScenarioShortlist,
        upper_bounds: optimization_params[activePortfolioID]["upper_bounds"],
        setFundTypeStyleError,
        universeLiteValidation,
        ownSecurityUniverse,
      });
      this.setState({
        classification_validated_data: classificationValidation,
      });
    } else {
      this.setState({
        classification_validated_data: asset_class,
      });
    }
  };

  style_validation_and_modify = ({
    styles,
    optimization_params,
    getScenarioShortlist,
    activePortfolioID,
    validate_slider_limits,
    setFundTypeStyleError,
    universeLiteValidation,
    ownSecurityUniverse,
  }) => {
    if (
      validate_slider_limits &&
      styles &&
      styles.length &&
      optimization_params
    ) {
      let styleValidation = helper.styleSliderValidataion({
        styles,
        symbols: getScenarioShortlist,
        upper_bounds: optimization_params[activePortfolioID]["upper_bounds"],
        setFundTypeStyleError,
        universeLiteValidation,
        ownSecurityUniverse,
      });
      this.setState({
        style_validated_data: styleValidation,
      });
    } else {
      this.setState({
        style_validated_data: styles,
      });
    }
  };

  getChar = ({ sentence }) => {
    if (!sentence) return;

    let list = sentence.split(" ");

    if (list.length > 1) {
      var matches = sentence.match(/\b(\w)/g);
      var acronym = matches.join("");

      return acronym;
    } else {
      let str = sentence[0] + sentence[1];

      return str;
    }
  };
  getColorsForCircleIcons = ({ colorList, array }) => {
    if (array && array.length > 0) {
      let colorsObj = {};

      for (let i = 0; i < array.length; i++) {
        let name = array[i]["name"].toLowerCase();
        colorsObj[name] = colorList[i];
      }
      return colorsObj;
    }
  };
  get_min_max = ({ name, data, type = "name", shouldReturn = "string" }) => {
    if (data && data.length > 0) {
      let OBJ = data.filter(
        (obj) => obj[type].toLowerCase() === name.toLowerCase()
      );

      let obj = OBJ ? OBJ[0] : false;
      if (obj) {
        let { min, max } = obj;

        if (shouldReturn === "string") {
          return `${(min * 100).toFixed()}-${(max * 100).toFixed()}`;
        } else {
          return { min: +(min * 100).toFixed(), max: +(max * 100).toFixed() };
        }
      } else {
        if (shouldReturn === "string") {
          return;
        } else {
          return { min: 0, max: 0 };
        }
      }
    } else if (shouldReturn === "string") {
      return "-";
    } else if (shouldReturn === "object") {
      return { min: 0, max: 0 };
    }
  };
  getColors = ({ str, group }) => {
    let clr =
      str.toLowerCase() === "mega cap" && str in group === false
        ? "#a70000"
        : str
        ? group[str.toLowerCase()]
        : "";
    return clr;
  };
  checkSliderRangeError = ({ data, name, type }) => {
    let typ = type ? type : "name";
    let filtered =
      data &&
      data.length > 0 &&
      data.filter(
        (e) => e[typ].toLocaleLowerCase() === name.toLocaleLowerCase()
      );
    let res;

    if (filtered && filtered.length) {
      res = filtered[0]["slider_error"];
    } else {
      res = false;
    }
    return res;
  };
  sliderDisplayHandler = (e, ID) => {
    e.preventDefault();
    if ("range" === e.target.type || "number" === e.target.type) {
      return false;
    }
    let id = ID ? ID : e.target.getAttribute("id");

    let { activeSliders } = this.state;

    let isIdIncludesinList = activeSliders.includes(id);

    let element = document.getElementById(id);
    let spanTag = element ? element.querySelector("span") : null;
    let contains =
      spanTag !== null
        ? spanTag.classList.contains("popuptext_visible")
        : false;

    if (activeSliders && activeSliders.length > 0) {
      for (let ids of activeSliders) {
        if (ids) {
          let el = document.getElementById(ids);
          let sTag = el ? el.querySelector("span") : null;
          if (sTag !== null && ids !== id) {
            sTag.classList.remove("popuptext_visible");
          }
        }
      }
      this.setState({
        activeSliders: [],
      });
    }
    if (id && isIdIncludesinList === false && isIdIncludesinList === false) {
      if (spanTag !== null) {
        spanTag.classList.add("popuptext_visible");

        this.setState({
          activeSliders: [id],
        });
      }
    } else if (contains) {
      spanTag.classList.remove("popuptext_visible");

      this.setState({
        activeSliders: [],
      });
    }
  };
  sliderRangeHandler = (obj) => {
    const { min, max, name, group } = obj;
    const { setDualSliderValues } = this.props;
    let object = { min, max, name, group };
    console.log("values from dual slider", obj);
    setDualSliderValues(object);
  };
  handleClickOutside = (e) => {
    let target_name = e.target.classList.value.trim();
    if (target_name) {
      target_name = target_name.split(" ")[0].trim();
    }
    if (
      target_name !== "" &&
      target_name !== "BuildPortfolio_custom_table_heading_tooltipHolder" &&
      target_name !== "BuildPortfolio_custom_table_subheading_tooltipHolder" &&
      target_name !== "circle-rect-icon" &&
      target_name !== "range-input-tf"
    ) {
      let { activeSliders } = this.state;

      if (activeSliders && activeSliders.length > 0) {
        for (let ids of activeSliders) {
          if (ids) {
            let el = document.getElementById(ids);
            let sTag = el ? el.querySelector("span") : null;
            if (sTag !== null) {
              sTag.classList.remove("popuptext_visible");
            }
          }
        }
        this.setState({
          activeSliders: [],
        });
      }
    }
    if (node) {
      // const domNode = ReactDOM.findDOMNode(node);
      if (node.current.contains(e.target)) {
        return false;
      } else {
        let { activeSliders } = this.state;

        if (activeSliders && activeSliders.length > 0) {
          for (let ids of activeSliders) {
            if (ids) {
              let el = document.getElementById(ids);
              let sTag = el ? el.querySelector("span") : null;
              if (sTag !== null) {
                sTag.classList.remove("popuptext_visible");
              }
            }
          }
          this.setState({
            activeSliders: [],
          });
        }
      }
    }
  };
  toggleStyleRowHandler = ({ e, cls }) => {
    e.preventDefault();
    let { target } = e;
    let plus = [...target.classList].includes("fa-plus");

    let opened_styles = [...this.state.opened_style];
    // console.log("cls", cls);
    if (plus === true) {
      target.classList.remove("fa-plus");
      target.classList.add("fa-minus");

      if (!opened_styles.includes(cls)) {
        opened_styles.push(cls);
        this.setState({
          opened_style: opened_styles,
        });
      }
    } else {
      target.classList.add("fa-plus");
      target.classList.remove("fa-minus");

      if (opened_styles.includes(cls)) {
        let _op_filtered = opened_styles.filter((e) => e !== cls);
        this.setState({
          opened_style: _op_filtered,
        });
      }
    }

    let listOfStyles = document.querySelectorAll(`.${cls}`);

    for (let i = 0; i < listOfStyles.length; i++) {
      let item = listOfStyles[i];
      let condition = [...item.classList].includes("hideBuildTableCell");

      if (condition) {
        item.classList.remove("hideBuildTableCell");
        item.classList.add("showBuildTableCell");
      } else {
        item.classList.add("hideBuildTableCell");
        item.classList.remove("showBuildTableCell");
      }
    }
  };

  maxAllocation = (value) => {
    const {
      getScenarioShortlist,
      allocation_max_limit,
      apply_max_to_allocation_ip,
    } = this.props;
    let filteredData = getScenarioShortlist.filter(
      (el) => el.val > parseFloat(allocation_max_limit)
    );
    if (value && apply_max_to_allocation_ip !== false) {
      let element = document.getElementById(`inputMaxAlertSecurities`);
      if (
        element &&
        allocation_max_limit &&
        (parseFloat(value) > parseFloat(allocation_max_limit) ||
          filteredData.length > 0)
      ) {
        element.innerHTML = ` Input value should be lesser than max-limit (${allocation_max_limit})`;
      } else if (element) {
        element.innerHTML = "";
      }
    }
  };
  AllocationHandler = (e) => {
    e.preventDefault();
    const {
      allocationHandler,
      allocation_max_limit,
      apply_max_to_allocation_ip,
    } = this.props;
    let target_val = e.target.value;
    const value =
      target_val === 0 || target_val === "" || target_val < 0
        ? ""
        : target_val * 1;
    const symbol = e.target.getAttribute("data-symbol");
    if (value === "") {
      allocationHandler({ symbol, value });
      e.target.value = "";
    } else if (value >= 0 && value <= allocation_max_limit) {
      allocationHandler({ symbol, value });
    } else if (value >= 0 && apply_max_to_allocation_ip === false) {
      allocationHandler({ symbol, value });
    } else {
      this.setState({
        allocation_max_warning: true,
      });

      setTimeout(
        () =>
          this.setState({
            allocation_max_warning: false,
          }),
        5000
      );
    }
    this.maxAllocation(value);
  };

  deleteRowHandler = (e) => {
    const { listOfSecuritiesToDelete, undoListOfSecuritiesToDelete } =
      this.props;
    let img_status = e.target.getAttribute("img-current");
    let parent_id = e.target.getAttribute("data-parent-id");
    let id = document.getElementById(parent_id);
    let input_tag;

    let symbol = e.target.getAttribute("data-symbol");

    if (id) {
      input_tag = id.getElementsByTagName("input");
    }

    if (img_status === "delete") {
      e.target.src = Undo;
      e.target.setAttribute("img-current", "undo");
      // id.style.opacity = 0.5;
      if (id.children[0].children[1]) {
        id.children[0].children[1].style.opacity = 0.5;
      }
      if (id.children[0].children[0]) {
        id.children[0].children[0].children[1].style.opacity = 0.5;
        id.children[0].children[0].lastElementChild.style.opacity = 0.5;
      }

      // disable input field
      if (
        input_tag &&
        input_tag[0] &&
        input_tag[0].classList.contains("core_allcn_ip") === false
      ) {
        input_tag[0].disabled = "true";
      } else if (input_tag && input_tag[1]) {
        input_tag[1].disabled = "true";
      }
      listOfSecuritiesToDelete(symbol);
      this.setState({
        listOfSecuritiesToDelete_manager_selection: [
          ...this.state.listOfSecuritiesToDelete_manager_selection,
          symbol,
        ],
      });
    } else {
      e.target.src = Delete;
      e.target.setAttribute("img-current", "delete");
      // id.style.opacity = 1;
      if (id.children[0].children[1]) {
        id.children[0].children[1].style.opacity = 1;
      }
      if (id.children[0].children[0]) {
        id.children[0].children[0].children[1].style.opacity = 1;
        id.children[0].children[0].lastElementChild.style.opacity = 1;
      }
      //remove disabled input field
      if (
        input_tag &&
        input_tag[0] &&
        input_tag[0].classList.contains("core_allcn_ip") === false
      ) {
        input_tag[0].removeAttribute("disabled");
      } else if (input_tag && input_tag[1]) {
        input_tag[1].removeAttribute("disabled");
      }
      undoListOfSecuritiesToDelete(symbol);
      this.setState({
        listOfSecuritiesToDelete_manager_selection: [
          ...this.state.listOfSecuritiesToDelete_manager_selection,
        ].filter((e) => e === symbol),
      });
    }
  };

  set_cash_assetClass_min_max_value = () => {
    const { single_asset_class_style, overall_focus, setDualSliderValues } =
      this.props;
    // setting cash asset class value to 100 - total of other asset classes
    if (single_asset_class_style && overall_focus && overall_focus.length > 0) {
      let min = 0;
      let max =
        100 -
        overall_focus
          // .filter((e) => e.name.toLowerCase() !== "cash")
          .map((a) => a.max * 1)
          .reduce((a, b) => a * 1 + b * 1) *
          100;

      let object = {
        min,
        max: max < 0 ? 0 : max,
        name: "Cash",
        group: "overall_focus",
      };
      setDualSliderValues(object);
    }
  };

  sortArrowUp = (e) => {
    const { grouped_data } = this.state;
    const { symbol_orders } = this.props;
    const symbol = e.target.getAttribute("data-symbol");
    const column = e.target.getAttribute("data-column_name");

    let data = grouped_data[0][column];

    let _clone_symbol_orders = { ...symbol_orders };

    let idx = data.findIndex((e) => e.symbol === symbol);

    if (idx > 0) {
      // change symbol order
      _clone_symbol_orders[symbol] = _clone_symbol_orders[symbol] - 1;

      let _above_symbol = data[idx - 1]["symbol"];
      _clone_symbol_orders[_above_symbol] = symbol_orders[_above_symbol] + 1;

      // change object order
      let el = data[idx];
      data[idx] = data[idx - 1];
      data[idx - 1] = el;
    }

    this.props.setSymbolsOrder(_clone_symbol_orders);
    let modified_data = grouped_data;
    modified_data[0][column] = data;

    this.setState({
      grouped_data: modified_data,
    });
  };

  sortArrowDown = (e) => {
    const { grouped_data } = this.state;
    const { symbol_orders } = this.props;
    const symbol = e.target.getAttribute("data-symbol");
    const column = e.target.getAttribute("data-column_name");

    let data = grouped_data[0][column];

    let modified_data = grouped_data;
    modified_data[0][column] = data;

    let _clone_symbol_orders = { ...symbol_orders };

    let idx = data.findIndex((e) => e.symbol === symbol);
    if (idx !== -1 && idx < data.length - 1) {
      // change symbol order
      _clone_symbol_orders[symbol] = _clone_symbol_orders[symbol] + 1;

      let _below_symbol = data[idx + 1]["symbol"];
      _clone_symbol_orders[_below_symbol] = symbol_orders[_below_symbol] - 1;

      // change object order
      let el = data[idx];
      data[idx] = data[idx + 1];
      data[idx + 1] = el;
    }

    this.props.setSymbolsOrder(_clone_symbol_orders);

    this.setState({
      grouped_data: modified_data,
    });
  };
  toggleSwitchHandler = ({ type }) => {
    const { toggleChartStatus, toggleStatsStatus } = this.state;
    if (
      type === "toggleChartStatus" &&
      toggleChartStatus === false &&
      toggleStatsStatus === false
    ) {
      this.setState({
        toggleChartStatus: true,
        toggleStatsStatus: true,
      });
    } else {
      this.setState({
        [type]: !this.state[type],
      });
    }
  };
  render() {
    const {
      slider_colors,
      grouped_data,
      colorsAssetClassGroups,
      styleAssetClassGroups,
      asset_class_validated_data,
      classification_validated_data,
      style_validated_data,
      colorClassificationGroup,
      classification_colors,
      resetRangeSlider,
      toggleStatsStatus,
      toggleChartStatus,
      opened_style,
    } = this.state;
    const {
      activePortfolioID,
      minMaxZeroToHundred,
      allocationInputField,
      allocation_max_limit,
      deleteRow,
      single_asset_class_style,
      buildPortfolioType,
      deleteSecurities,
      apply_max_to_allocation_ip,
      getScenarioShortlist,
      original_allocation_display,
    } = this.props;

    // if asset_class has only one type then excluding class type - display classification circle_rect
    const circleRect_classification_condition =
      single_asset_class_style &&
      asset_class_validated_data &&
      (asset_class_validated_data.length === 1 ||
        (asset_class_validated_data.length === 2 &&
          asset_class_validated_data.filter(
            (e) => e.name.toLowerCase() === "cash"
          ).length === 1)) &&
      classification_validated_data &&
      classification_validated_data.length > 0;

    return (
      <Fragment>
        {/* {allocation_max_warning ? ( */}
        <div
          className="dataWarning"
          style={{
            display: "block",
            margin: "5px",
            textAlign: "right",
          }}
        >
          <span
            className="dataWarning"
            id={`inputMaxAlertSecurities`}
            style={{ padding: "5px 0px" }}
          ></span>
        </div>
        {/* ) : null} */}

        <div className="BuildPortfolio_holder" ref={node}>
          <div className="BuildPortfolio_holder_assetClass">
            <AssetClassGroup
              filterCash={false}
              asset_class_validated_data={asset_class_validated_data}
              resetRangeSlider={resetRangeSlider}
              activePortfolioID={activePortfolioID}
              slider_colors={slider_colors}
              minMaxZeroToHundred={minMaxZeroToHundred}
              getChar={this.getChar}
              sliderDisplayHandler={this.sliderDisplayHandler}
              sliderRangeHandler={this.sliderRangeHandler}
              displayRangeSlider={
                buildPortfolioType === "managerSelection" ? false : true
              }
              getScenarioShortlist={getScenarioShortlist}
              exclamation_warning={true}
            />
            {circleRect_classification_condition ? (
              <ClassificationGroup
                activePortfolioID={activePortfolioID}
                classification_colors={classification_colors}
                classification_validated_data={classification_validated_data}
                getChar={this.getChar}
                minMaxZeroToHundred={minMaxZeroToHundred}
                sliderDisplayHandler={this.sliderDisplayHandler}
                sliderRangeHandler={this.sliderRangeHandler}
                displayRangeSlider={
                  buildPortfolioType === "managerSelection" ? false : true
                }
              />
            ) : null}
            <div className="BuildPortfolio_holder_assetClass_stats">
              <div>
                <label>STATS:</label>
                <ToggleSwitch
                  id="toggleSwitch01"
                  checked={toggleStatsStatus}
                  handler={() =>
                    this.toggleSwitchHandler({
                      type: "toggleStatsStatus",
                    })
                  }
                />
              </div>
              <div>
                <label>CHARTS:</label>
                <ToggleSwitch
                  id="toggleSwitch02"
                  checked={toggleChartStatus}
                  handler={() =>
                    this.toggleSwitchHandler({
                      type: "toggleChartStatus",
                    })
                  }
                />
              </div>
            </div>
          </div>
          {grouped_data && grouped_data.length > 0 ? (
            <div className="BuildPortfolio_custom_table">
              <Fragment>
                {Object.keys(grouped_data[0]).map((e, idx) => {
                  return (
                    <div
                      key={`${e}-${activePortfolioID}-${idx}`}
                      className="BuildPortfolio_custom_table_column"
                    >
                      {grouped_data[0][e].map((ob, i, listOfData) => (
                        <Fragment
                          key={`{${ob["symbol"]}-${i}}-${activePortfolioID}`}
                        >
                          {ob["heading"] ? (
                            //  &&
                            // (circleRect_classification_condition
                            //   ? ob["heading"].toLowerCase() !== "cash"
                            //   : true)
                            <div className="BuildPortfolio_custom_table_heading">
                              <div>
                                {colorsAssetClassGroups &&
                                styleAssetClassGroups ? (
                                  <Fragment key={uniqueId()}>
                                    <CircleIcon
                                      color={this.getColors({
                                        str: styleAssetClassGroups[
                                          ob["heading"].toLowerCase()
                                        ],
                                        group: colorsAssetClassGroups,
                                      })}
                                      label={this.getChar({
                                        sentence:
                                          styleAssetClassGroups[
                                            ob["heading"].toLowerCase()
                                          ],
                                      })}
                                      fullLabel={ob["asset_class"]}
                                      tooltipID={
                                        ob["heading"].toLowerCase() + idx
                                      }
                                      iconTooltipID={`${ob["heading"]}_${idx}`}
                                    />
                                    {ob["heading"]}
                                  </Fragment>
                                ) : null}
                              </div>
                              <div
                                className="BuildPortfolio_custom_table_heading_g1"
                                style={{
                                  cursor:
                                    buildPortfolioType === "managerSelection"
                                      ? "default"
                                      : "pointer",
                                }}
                              >
                                <div
                                  className={`BuildPortfolio_custom_table_heading_tooltipHolder ${
                                    this.checkSliderRangeError({
                                      data: classification_validated_data,
                                      name: ob["heading"],
                                    })
                                      ? "color-error"
                                      : null
                                  }`}
                                  id={`${ob["heading"].replace(
                                    regex,
                                    ""
                                  )}-heading-${i}-${activePortfolioID}`}
                                  onClick={(e) => this.sliderDisplayHandler(e)}
                                >
                                  {/* {ob["heading"].toLocaleLowerCase() !==
                                  "cash" ? ( */}
                                  <Fragment>
                                    {console.log(
                                      `${ob["heading"]}`,
                                      this.get_min_max({
                                        name: ob["heading"],
                                        data: classification_validated_data,
                                        shouldReturn: "string",
                                      })
                                    )}
                                    {this.get_min_max({
                                      name: ob["heading"],
                                      data: classification_validated_data,
                                      shouldReturn: "string",
                                    })}
                                    <Fragment>
                                      {buildPortfolioType !==
                                      "managerSelection" ? (
                                        <span className="BuildPortfolio_custom_table_heading_tooltipHolder_popuptext ">
                                          <SliderWithPercent
                                            min={
                                              this.get_min_max({
                                                name: ob["heading"],
                                                data: classification_validated_data,
                                                shouldReturn: "object",
                                              }).min
                                            }
                                            max={
                                              this.get_min_max({
                                                name: ob["heading"],
                                                data: classification_validated_data,
                                                shouldReturn: "object",
                                              }).max
                                            }
                                            minMaxZeroToHundred={
                                              minMaxZeroToHundred
                                            }
                                            ID={`${ob["heading"].replace(
                                              regex,
                                              ""
                                            )}-slider-${idx}-${activePortfolioID}`}
                                            group="asset_class"
                                            name={ob["heading"]}
                                            Sliderhandler={(obj) =>
                                              this.sliderRangeHandler(obj)
                                            }
                                            bg_warning={this.checkSliderRangeError(
                                              {
                                                data: classification_validated_data,
                                                name: ob["heading"],
                                              }
                                            )}
                                          />
                                        </span>
                                      ) : null}
                                    </Fragment>
                                  </Fragment>
                                  {/* ) : null} */}
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {ob["heading"] &&
                            toggleStatsStatus &&
                            opened_style.some((e) =>
                              e.includes(
                                ob["heading"]
                                  ? ob["heading"].replace(regex, "")
                                  : ""
                              )
                            ) && (
                              <div
                                className={`BuildPortfolio_custom_table_graphHeading
                            ${opened_style.includes(
                              ob["new_style"] && ob["new_classification"]
                                ? circleRect_classification_condition
                                  ? ob["new_style"].replace(regex, "")
                                  : ob["new_style"].replace(regex, "") +
                                    ob["new_classification"].replace(regex, "")
                                : ""
                            )}
                              ? "showBuildTableCell"
                              : "hideBuildTableCell"
                            `}
                              >
                                <div className="BuildPortfolio_custom_table_graphHeading_c1">
                                  1 YR
                                </div>
                                <div className="BuildPortfolio_custom_table_graphHeading_c2">
                                  3 YR
                                </div>
                                <div className="BuildPortfolio_custom_table_graphHeading_c3">
                                  5 YR
                                </div>
                              </div>
                            )}

                          {ob["subheading"] &&
                          (circleRect_classification_condition
                            ? ob["subheading"].toLowerCase() !== "cash"
                            : true) ? (
                            <div
                              className={`BuildPortfolio_custom_table_subheading ${
                                opened_style.includes(
                                  ob["subheading"] && ob["classification"]
                                    ? ob["subheading"].replace(regex, "") +
                                        ob["classification"].replace(regex, "")
                                    : ""
                                )
                                  ? "grey86"
                                  : ""
                              }`}
                            >
                              {ob["subheading"] !== "dummy" ? (
                                <i
                                  className={`fa ${
                                    ob["subheading"] ? "fa-plus" : ""
                                  }`}
                                  arial-hidden="true"
                                  onClick={(e) =>
                                    this.toggleStyleRowHandler({
                                      e,
                                      cls: circleRect_classification_condition
                                        ? ob["subheading"].replace(regex, "")
                                        : ob["subheading"].replace(regex, "") +
                                          ob["classification"].replace(
                                            regex,
                                            ""
                                          ),
                                    })
                                  }
                                />
                              ) : null}
                              {circleRect_classification_condition &&
                              ob["assetClass"] &&
                              ob["subheading"] !== "dummy" ? (
                                <Fragment key={uniqueId()}>
                                  <CircleIcon
                                    color={this.getColors({
                                      str: ob["assetClass"].toLowerCase(),
                                      group: colorsAssetClassGroups,
                                    })}
                                    label={this.getChar({
                                      sentence:
                                        ob["assetClass"].toLowerCase() ===
                                        "mid cap"
                                          ? ob["assetClass"].split(" ").join("")
                                          : ob["assetClass"].toLowerCase() ===
                                            "multi cap"
                                          ? ob["assetClass"].split(" ").join("")
                                          : ob["assetClass"].toLowerCase() ===
                                            "mega cap"
                                          ? ob["assetClass"].split(" ").join("")
                                          : ob["assetClass"],
                                    })}
                                    fullLabel={ob["assetClass"]}
                                    style={{
                                      marginRight: "5px",
                                    }}
                                    tooltipID={
                                      ob["assetClass"].toLowerCase() + idx
                                    }
                                    iconTooltipID={`${ob[
                                      "assetClass"
                                    ].toLowerCase()}_${idx}`}
                                  />
                                </Fragment>
                              ) : null}
                              {ob["subheading"] !== "dummy" && (
                                <div>{ob["subheading"]}</div>
                              )}

                              <div
                                className="BuildPortfolio_custom_table_subheading_g1"
                                style={{
                                  cursor:
                                    buildPortfolioType === "managerSelection"
                                      ? "default"
                                      : "pointer",
                                }}
                              >
                                {ob["subheading"] !== "dummy" ? (
                                  <div
                                    className={`BuildPortfolio_custom_table_subheading_tooltipHolder ${
                                      this.checkSliderRangeError({
                                        data: style_validated_data,
                                        name: ob["subheading"],
                                        type: "style",
                                      })
                                        ? "color-error"
                                        : null
                                    }`}
                                    id={`${ob["subheading"].replace(
                                      regex,
                                      ""
                                    )}-subheading-${i}-${activePortfolioID}`}
                                    onClick={(e) =>
                                      this.sliderDisplayHandler(e)
                                    }
                                  >
                                    {/* {ob["subheading"].toLocaleLowerCase() !==
                                    "cash" ? ( */}
                                    <Fragment>
                                      {this.get_min_max({
                                        name: ob["subheading"],
                                        data: style_validated_data,
                                        type: "style",
                                        shouldReturn: "string",
                                      })}
                                      <Fragment>
                                        {buildPortfolioType !==
                                        "managerSelection" ? (
                                          <span className="BuildPortfolio_custom_table_subheading_tooltipHolder_popuptext ">
                                            <SliderWithPercent
                                              min={
                                                this.get_min_max({
                                                  name: ob["subheading"],
                                                  data: style_validated_data,
                                                  type: "style",
                                                  shouldReturn: "object",
                                                }).min
                                              }
                                              max={
                                                this.get_min_max({
                                                  name: ob["subheading"],
                                                  data: style_validated_data,
                                                  type: "style",
                                                  shouldReturn: "object",
                                                }).max
                                              }
                                              minMaxZeroToHundred={
                                                minMaxZeroToHundred
                                              }
                                              ID={`${ob["subheading"].replace(
                                                regex,
                                                ""
                                              )}-slider-subheading-${idx}-${activePortfolioID}`}
                                              group="styles"
                                              name={ob["subheading"]}
                                              Sliderhandler={(obj) =>
                                                this.sliderRangeHandler(obj)
                                              }
                                              bg_warning={this.checkSliderRangeError(
                                                {
                                                  data: style_validated_data,
                                                  name: ob["subheading"],
                                                  type: "style",
                                                }
                                              )}
                                            />
                                          </span>
                                        ) : null}
                                      </Fragment>
                                    </Fragment>
                                    {/* // ) : null} */}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          ) : null}

                          {ob["symbol"] &&
                          (circleRect_classification_condition
                            ? ob["symbol"].toLowerCase() !== "cash"
                            : true) ? (
                            <div
                              className={`BuildPortfolio_custom_table_cell ${
                                ob["new_style"] && ob["new_classification"]
                                  ? circleRect_classification_condition
                                    ? ob["new_style"].replace(regex, "")
                                    : ob["new_style"].replace(regex, "") +
                                      ob["new_classification"].replace(
                                        regex,
                                        ""
                                      )
                                  : ""
                              } 

                              
                              ${
                                ob["new_style"] &&
                                ob["new_classification"] &&
                                circleRect_classification_condition
                                  ? opened_style.includes(
                                      ob["new_style"].replace(regex, "")
                                    )
                                    ? "showBuildTableCell"
                                    : "hideBuildTableCell"
                                  : opened_style.includes(
                                      ob["new_style"].replace(regex, "") +
                                        ob["new_classification"].replace(
                                          regex,
                                          ""
                                        )
                                    )
                                  ? "showBuildTableCell"
                                  : "hideBuildTableCell"
                              } 
                              
                              ${
                                circleRect_classification_condition
                                  ? "brd-top-blue"
                                  : ""
                              }
                              `}
                              id={`${
                                ob["new_style"] &&
                                ob["new_classification"] &&
                                ob["fund_name"]
                                  ? ob["new_style"].replace(regex, "") +
                                    ob["new_classification"].replace(
                                      regex,
                                      ""
                                    ) +
                                    ob["fund_name"].replace(regex, "")
                                  : ""
                              }`}
                            >
                              <div
                                className="BuildPortfolio_custom_table_cell_g1"
                                style={{
                                  paddingLeft: deleteRow ? "35px" : "45px",
                                }}
                              >
                                <div
                                  className={
                                    deleteRow &&
                                    circleRect_classification_condition
                                      ? "d-flex-align-center"
                                      : deleteRow
                                      ? "del_img_container"
                                      : circleRect_classification_condition
                                      ? "circle-icon-label-cell"
                                      : ""
                                  }
                                >
                                  {deleteRow ? (
                                    <img
                                      src={
                                        `${
                                          buildPortfolioType ===
                                          "managerSelection"
                                        }` &&
                                        deleteSecurities &&
                                        deleteSecurities.includes(ob["symbol"])
                                          ? Undo
                                          : Delete
                                      }
                                      alt="delete/undo"
                                      className="BuildPortfolio_custom_table_cell_g1_img"
                                      img-current={
                                        `${
                                          buildPortfolioType ===
                                          "managerSelection"
                                        }` &&
                                        deleteSecurities &&
                                        deleteSecurities.includes(ob["symbol"])
                                          ? "undo"
                                          : "delete"
                                      }
                                      data-parent-id={`${
                                        ob["new_style"] &&
                                        ob["new_classification"] &&
                                        ob["fund_name"]
                                          ? ob["new_style"].replace(regex, "") +
                                            ob["new_classification"].replace(
                                              regex,
                                              ""
                                            ) +
                                            ob["fund_name"].replace(regex, "")
                                          : ""
                                      }`}
                                      data-symbol={ob["symbol"]}
                                      data-node={1}
                                      onClick={(e, ob) =>
                                        this.deleteRowHandler(e)
                                      }
                                    ></img>
                                  ) : null}
                                  {circleRect_classification_condition &&
                                  colorClassificationGroup &&
                                  ob["new_classification"] ? (
                                    <Fragment key={uniqueId()}>
                                      <CircleIcon
                                        color={this.getColors({
                                          str: ob[
                                            "new_classification"
                                          ].toLowerCase(),
                                          group: colorClassificationGroup,
                                        })}
                                        label={this.getChar({
                                          sentence:
                                            ob[
                                              "new_classification"
                                            ].toLowerCase() === "mid cap"
                                              ? ob["new_classification"]
                                                  .split(" ")
                                                  .join("")
                                              : ob[
                                                  "new_classification"
                                                ].toLowerCase() === "multi cap"
                                              ? ob["new_classification"]
                                                  .split(" ")
                                                  .join("")
                                              : ob[
                                                  "new_classification"
                                                ].toLowerCase() === "mega cap"
                                              ? ob["new_classification"]
                                                  .split(" ")
                                                  .join("")
                                              : ob["new_classification"],
                                        })}
                                        fullLabel={ob["new_classification"]}
                                        iconTooltipID={`${ob[
                                          "new_classification"
                                        ].toLowerCase()}`}
                                      />
                                    </Fragment>
                                  ) : null}
                                  <span
                                    style={{
                                      opacity:
                                        (buildPortfolioType ===
                                          "managerSelection" ||
                                          buildPortfolioType ===
                                            "customPortfolio") &&
                                        deleteSecurities &&
                                        deleteSecurities.includes(ob["symbol"])
                                          ? ".5"
                                          : "",
                                    }}
                                  >
                                    {" "}
                                    {ob["fund_name"]}
                                  </span>
                                </div>

                                {buildPortfolioType === "managerSelection" &&
                                circleRect_classification_condition === false &&
                                this.props.type === "build_a_portfolio" ? (
                                  <div
                                    style={{
                                      paddingRight: "15px",
                                      opacity:
                                        (buildPortfolioType ===
                                          "managerSelection" ||
                                          buildPortfolioType ===
                                            "customPortfolio") &&
                                        deleteSecurities &&
                                        deleteSecurities.includes(ob["symbol"])
                                          ? ".5"
                                          : "",
                                    }}
                                  >
                                    {"subheading" in listOfData[i - 1] ||
                                    "heading" in listOfData[i - 1] ||
                                    (ob["new_style"] &&
                                      ob["new_style"].toLowerCase() ===
                                        "cash") ? null : (
                                      <i
                                        style={{
                                          pointerEvents:
                                            (buildPortfolioType ===
                                              "managerSelection" ||
                                              buildPortfolioType ===
                                                "customPortfolio") &&
                                            deleteSecurities &&
                                            deleteSecurities.includes(
                                              ob["symbol"]
                                            )
                                              ? "none"
                                              : "all",
                                        }}
                                        className="fa fa-caret-up"
                                        data-index={i}
                                        data-symbol={ob.symbol}
                                        data-column_name={e}
                                        data-move="up"
                                        data-common_class_name={
                                          ob["new_style"].replace(regex, "") +
                                          ob["new_classification"].replace(
                                            regex,
                                            ""
                                          )
                                        }
                                        onClick={(e) => this.sortArrowUp(e)}
                                      ></i>
                                    )}
                                    {i === listOfData.length - 1 ||
                                    "subheading" in listOfData[i + 1] ||
                                    "heading" in listOfData[i + 1] ||
                                    (ob["new_style"] &&
                                      ob["new_style"].toLowerCase() ===
                                        "cash") ? null : (
                                      <i
                                        style={{
                                          pointerEvents:
                                            (buildPortfolioType ===
                                              "managerSelection" ||
                                              buildPortfolioType ===
                                                "customPortfolio") &&
                                            deleteSecurities &&
                                            deleteSecurities.includes(
                                              ob["symbol"]
                                            )
                                              ? "none"
                                              : "all",
                                        }}
                                        className="fa fa-caret-down"
                                        data-index={i}
                                        data-symbol={ob.symbol}
                                        data-column_name={e}
                                        data-move="down"
                                        data-common_class_name={
                                          ob["new_style"].replace(regex, "") +
                                          ob["new_classification"].replace(
                                            regex,
                                            ""
                                          )
                                        }
                                        onClick={(e) => this.sortArrowDown(e)}
                                      ></i>
                                    )}
                                  </div>
                                ) : null}
                                {original_allocation_display &&
                                  ob.hasOwnProperty("original_allocation") && (
                                    <input
                                      type="number"
                                      defaultValue={ob.original_allocation}
                                      className="core_allcn_ip"
                                      disabled
                                    ></input>
                                  )}
                                {allocationInputField &&
                                +allocation_max_limit >= 0 &&
                                original_allocation_display === false ? (
                                  <input
                                    type="number"
                                    data-symbol={ob.symbol}
                                    min={0}
                                    max={allocation_max_limit}
                                    defaultValue={ob["val"]}
                                    onChange={(e) => this.AllocationHandler(e)}
                                  />
                                ) : allocationInputField &&
                                  apply_max_to_allocation_ip === false &&
                                  original_allocation_display ? (
                                  <input
                                    type="number"
                                    data-symbol={ob.symbol}
                                    min={0}
                                    defaultValue={ob["core_allocation"]}
                                    onChange={(e) => this.AllocationHandler(e)}
                                  />
                                ) : allocationInputField &&
                                  apply_max_to_allocation_ip === false ? (
                                  <input
                                    type="number"
                                    data-symbol={ob.symbol}
                                    min={0}
                                    defaultValue={ob["val"]}
                                    onChange={(e) => this.AllocationHandler(e)}
                                  />
                                ) : null}
                              </div>
                            </div>
                          ) : null}

                          {toggleStatsStatus &&
                            ob["new_style"] &&
                            toggleChartStatus === false && (
                              <div
                                className={`BuildPortfolio_custom_table_graphs
                                    ${
                                      ob["new_style"] &&
                                      ob["new_classification"]
                                        ? circleRect_classification_condition
                                          ? ob["new_style"].replace(regex, "")
                                          : ob["new_style"].replace(regex, "") +
                                            ob["new_classification"].replace(
                                              regex,
                                              ""
                                            )
                                        : ""
                                    }
                                  ${
                                    opened_style.includes(
                                      ob["new_style"].replace(regex, "") +
                                        ob["new_classification"].replace(
                                          regex,
                                          ""
                                        )
                                    ) ||
                                    opened_style.includes(
                                      ob["new_style"] &&
                                        ob["new_classification"]
                                        ? circleRect_classification_condition
                                          ? ob["new_style"].replace(regex, "")
                                          : ob["new_style"].replace(regex, "") +
                                            ob["new_classification"].replace(
                                              regex,
                                              ""
                                            )
                                        : ""
                                    )
                                      ? "showBuildTableCell"
                                      : "hideBuildTableCell"
                                  } 
                                  `}
                              >
                                <Cells
                                  value_1={
                                    ob.return_1yr ? ob.return_1yr * 100 : 0
                                  }
                                  value_2={
                                    ob.fi_bm_return_1yr
                                      ? ob.fi_bm_return_1yr * 100
                                      : 0
                                  }
                                  value_3={
                                    ob.eq_bm_return_1yr
                                      ? ob.eq_bm_return_1yr * 100
                                      : 0
                                  }
                                  title={"1 YR Return"}
                                  paddingLeft={true}
                                />
                                <Cells
                                  value_1={
                                    ob.return_3yr ? ob.return_3yr * 100 : 0
                                  }
                                  value_2={
                                    ob.fi_bm_return_3yr
                                      ? ob.fi_bm_return_3yr * 100
                                      : 0
                                  }
                                  value_3={
                                    ob.eq_bm_return_3yr
                                      ? ob.eq_bm_return_3yr * 100
                                      : 0
                                  }
                                  pl_17={true}
                                  pr_18={true}
                                  title={"3 YR Return"}
                                />
                                <Cells
                                  value_1={
                                    ob.return_5yr ? ob.return_5yr * 100 : 0
                                  }
                                  value_2={
                                    ob.fi_bm_return_5yr
                                      ? ob.fi_bm_return_5yr * 100
                                      : 0
                                  }
                                  value_3={
                                    ob.eq_bm_return_5yr
                                      ? ob.eq_bm_return_5yr * 100
                                      : 0
                                  }
                                  title={"5 YR Return"}
                                  pl_17={true}
                                  pr_18={true}
                                />
                              </div>
                            )}
                          {toggleStatsStatus &&
                            toggleChartStatus &&
                            ob["new_style"] && (
                              <div
                                className={`BuildPortfolio_custom_table_graphs
                              ${
                                ob["new_style"] && ob["new_classification"]
                                  ? circleRect_classification_condition
                                    ? ob["new_style"].replace(regex, "")
                                    : ob["new_style"].replace(regex, "") +
                                      ob["new_classification"].replace(
                                        regex,
                                        ""
                                      )
                                  : ""
                              }
                            ${
                              opened_style.includes(
                                ob["new_style"].replace(regex, "") +
                                  ob["new_classification"].replace(regex, "")
                              ) ||
                              opened_style.includes(
                                ob["new_style"] && ob["new_classification"]
                                  ? circleRect_classification_condition
                                    ? ob["new_style"].replace(regex, "")
                                    : ob["new_style"].replace(regex, "") +
                                      ob["new_classification"].replace(
                                        regex,
                                        ""
                                      )
                                  : ""
                              )
                                ? "showBuildTableCell"
                                : "hideBuildTableCell"
                            } 
                            `}
                              >
                                <div>
                                  {(!ob.return_1yr ||
                                    ob.return_1yr * 100 === 0) &&
                                  (!ob.fi_bm_return_1yr ||
                                    ob.fi_bm_return_1yr * 100 === 0) &&
                                  (!ob.fi_bm_return_1yr ||
                                    ob.eq_bm_return_1yr === 0) ? (
                                    "-"
                                  ) : (
                                    <Bars
                                      id={(
                                        "one" +
                                        ob.symbol.replace(regex, "") +
                                        ob.fund_name.replace(regex, "") +
                                        "tst"
                                      ).replace(/[^\w\s]/gi, "")}
                                      w={100}
                                      h={80}
                                      data={[
                                        {
                                          x: 1,
                                          value: ob.return_1yr
                                            ? ob.return_1yr * 100
                                            : 0,
                                          name: "1 YR Return",
                                          name2: "",
                                        },
                                        {
                                          x: 2,
                                          value: ob.fi_bm_return_1yr
                                            ? ob.fi_bm_return_1yr * 100
                                            : 0,
                                          name: "1 YR Return",
                                          name2: "FI BM",
                                        },
                                        {
                                          x: 3,
                                          value: ob.eq_bm_return_1yr
                                            ? ob.eq_bm_return_1yr * 100
                                            : 0,
                                          name: "1 YR Return",
                                          name2: "EQ BM",
                                        },
                                      ]}
                                      pl_35={true}
                                    />
                                  )}
                                </div>
                                <div>
                                  {(!ob.return_3yr ||
                                    ob.return_3yr * 100 === 0) &&
                                  (!ob.fi_bm_return_3yr ||
                                    ob.fi_bm_return_3yr * 100 === 0) &&
                                  (!ob.fi_bm_return_3yr ||
                                    ob.eq_bm_return_3yr === 0) ? (
                                    "-"
                                  ) : (
                                    <Bars
                                      id={(
                                        "two" +
                                        ob.symbol.replace(regex, "") +
                                        ob.fund_name.replace(regex, "") +
                                        "tst"
                                      ).replace(/[^\w\s]/gi, "")}
                                      w={100}
                                      h={80}
                                      data={[
                                        {
                                          x: 1,
                                          value: ob.return_3yr
                                            ? ob.return_3yr * 100
                                            : 0,
                                          name: "3 YR Return",
                                          name2: "",
                                        },
                                        {
                                          x: 2,
                                          value: ob.fi_bm_return_3yr
                                            ? ob.fi_bm_return_3yr * 100
                                            : 0,
                                          name: "3 YR Return",
                                          name2: "FI BM",
                                        },
                                        {
                                          x: 3,
                                          value: ob.eq_bm_return_3yr
                                            ? ob.eq_bm_return_3yr * 100
                                            : 0,
                                          name: "3 YR Return",
                                          name2: "EQ BM",
                                        },
                                      ]}
                                    />
                                  )}
                                </div>
                                <div>
                                  {(!ob.return_5yr ||
                                    ob.return_5yr * 100 === 0) &&
                                  (!ob.fi_bm_return_5yr ||
                                    ob.fi_bm_return_5yr * 100 === 0) &&
                                  (!ob.fi_bm_return_5yr ||
                                    ob.eq_bm_return_5yr === 0) ? (
                                    "-"
                                  ) : (
                                    <Bars
                                      id={(
                                        "three" +
                                        ob.symbol.replace(regex, "") +
                                        ob.fund_name.replace(regex, "") +
                                        "tst"
                                      ).replace(/[^\w\s]/gi, "")}
                                      w={100}
                                      h={80}
                                      data={[
                                        {
                                          x: 1,
                                          value: ob.return_5yr
                                            ? ob.return_5yr * 100
                                            : 0,
                                          name: "5 YR Return",
                                          name2: "",
                                        },
                                        {
                                          x: 2,
                                          value: ob.fi_bm_return_5yr
                                            ? ob.fi_bm_return_5yr * 100
                                            : 0,
                                          name: "5 YR Return",
                                          name2: "FI BM",
                                        },
                                        {
                                          x: 3,
                                          value: ob.eq_bm_return_5yr
                                            ? ob.eq_bm_return_5yr * 100
                                            : 0,
                                          name: "5 YR Return",
                                          name2: "EQ BM",
                                        },
                                      ]}
                                    />
                                  )}
                                </div>
                              </div>
                            )}
                        </Fragment>
                      ))}
                    </div>
                  );
                })}
              </Fragment>
            </div>
          ) : null}
        </div>
      </Fragment>
    );
  }
}
TreeTableWithSlider.defaultProps = {
  original_allocation_display: false,
};
TreeTableWithSlider.propTypes = {
  activePortfolioID: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  getScenarioShortlist: PropTypes.arrayOf(PropTypes.object).isRequired,
  overall_focus: PropTypes.arrayOf(PropTypes.object).isRequired,
  styles: PropTypes.arrayOf(PropTypes.object).isRequired,
  asset_class: PropTypes.arrayOf(PropTypes.object).isRequired,
  optimization_params: PropTypes.object,
  setDualSliderValues: PropTypes.func.isRequired,
  minMaxZeroToHundred: PropTypes.bool,
  allocationInputField: PropTypes.bool,
  allocationHandler: PropTypes.func,
  allocation_max_limit: PropTypes.number,
  deleteRow: PropTypes.bool,
  listOfSecuritiesToDelete: PropTypes.func,
  undoListOfSecuritiesToDelete: PropTypes.func,
  type: PropTypes.string,
  apply_max_to_allocation_ip: PropTypes.bool,
  original_allocation_display: PropTypes.bool,
};

export default connect(
  ({ create: { SecurityAddedManually, steps } }) => ({
    SecurityAddedManually,
    stepsCount: steps.stepsCount,
  }),
  null
)(TreeTableWithSlider);



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/TreeTableWithSlider.jsx